import styled from 'styled-components';

export const EnableWrap = styled.div`
  .tips-wrap {
    color: #a9adba;
    font-size: 12px;
    .tips-item{
        padding-left: 36px;
        margin-top: 8px;
    }
  }
`;
